import {PlayType} from "./playType";
import {PlayResult} from "./playResult";

export const playResultGroups : Record<PlayType, PlayResult[]> = {
  [PlayType['2Pt']]: [
    PlayResult.Good,
    PlayResult.NoGood,
    PlayResult.Penalty
  ],
  [PlayType['2PtDefend']]: [
    PlayResult.Good,
    PlayResult.NoGood,
    PlayResult.Penalty
  ],
  [PlayType.ExtraPt]: [
    PlayResult.Block,
    PlayResult.Good,
    PlayResult.NoGood,
    PlayResult.Penalty
  ],
  [PlayType.ExtraPtBlock]: [
    PlayResult.Block,
    PlayResult.Good,
    PlayResult.NoGood,
    PlayResult.Penalty
  ],
  [PlayType.FakeFG]: [
    PlayResult.Incomplete,
    PlayResult.IncompleteBattedDown,
    PlayResult.Interception,
    PlayResult.InterceptionDefTD,
    PlayResult.InterceptionFumble,
    PlayResult.Penalty,
    PlayResult.Simple,
    PlayResult.Rush,
    PlayResult.RushTD,
    PlayResult.SackFumble,
    PlayResult.SackFumbleDefTD,
    PlayResult.TD
  ],
  [PlayType.FakePunt]: [
    PlayResult.Incomplete,
    PlayResult.IncompleteBattedDown,
    PlayResult.Interception,
    PlayResult.InterceptionDefTD,
    PlayResult.InterceptionFumble,
    PlayResult.Sack,
    PlayResult.Penalty,
    PlayResult.PenaltySafety,
    PlayResult.Rush,
    PlayResult.RushSafety,
    PlayResult.RushTD,
    PlayResult.SackFumble,
    PlayResult.SackFumbleDefTD,
    PlayResult.SackSafety,
    PlayResult.Safety,
    PlayResult.TD
  ],
  [PlayType.FG]: [
    PlayResult.Good,
    PlayResult.Simple,
    PlayResult.NoGood,
    PlayResult.NoGoodDefTD,
    PlayResult.Return,
    PlayResult.Block,
    PlayResult.BlockDefTD,
    PlayResult.Penalty,
    PlayResult.TD
  ],
  [PlayType.FGBlock]: [
    PlayResult.Incomplete,
    PlayResult.IncompleteBattedDown,
    PlayResult.Interception,
    PlayResult.InterceptionDefTD,
    PlayResult.InterceptionFumble,
    PlayResult.Sack,
    PlayResult.Penalty,
    PlayResult.PenaltySafety,
    PlayResult.Rush,
    PlayResult.RushSafety,
    PlayResult.RushTD,
    PlayResult.SackFumble,
    PlayResult.SackFumbleDefTD,
    PlayResult.SackSafety,
    PlayResult.Safety,
    PlayResult.TD
  ],
  [PlayType.KO]: [
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.Penalty,
    PlayResult.Return,
    PlayResult.Simple,
    PlayResult.Safety,
    PlayResult.TouchBack,
    PlayResult.TD
  ],
  [PlayType.KOREC]: [
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.Penalty,
    PlayResult.Return,
    PlayResult.Simple,
    PlayResult.Safety,
    PlayResult.TouchBack,
    PlayResult.TD
  ],
  [PlayType.OnsideKick]: [
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.Penalty,
    PlayResult.Return,
    PlayResult.Simple,
    PlayResult.Safety,
    PlayResult.TD,
    PlayResult.TouchBack
  ],
  [PlayType.OnsideKickRec]: [
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.Penalty,
    PlayResult.Return,
    PlayResult.Simple,
    PlayResult.Safety,
    PlayResult.TD,
    PlayResult.TouchBack
  ],
  [PlayType.Pass]: [
    PlayResult.Complete,
    PlayResult.Incomplete,
    PlayResult.CompleteFumble,
    PlayResult.CompleteTD,
    PlayResult.IncompleteBattedDown,
    PlayResult.Penalty,
    PlayResult.Sack,
    PlayResult.SackFumble,
    PlayResult.SackFumbleDefTD,
    PlayResult.Interception,
    PlayResult.TeamLost,
    PlayResult.InterceptionDefTD,
    PlayResult.InterceptionFumble,
  ],
  [PlayType.Punt]: [
    PlayResult.Return,
    PlayResult.Simple,
    PlayResult.Block,
    PlayResult.BlockDefTD,
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.Penalty,
    PlayResult.PenaltySafety,
    PlayResult.TD,
    PlayResult.TeamLost,
    PlayResult.Safety,
    PlayResult.SafetyReceivingTeam
  ],
  [PlayType.PuntRec]: [
    PlayResult.Return,
    PlayResult.Simple,
    PlayResult.Block,
    PlayResult.BlockDefTD,
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.Penalty,
    PlayResult.PenaltySafety,
    PlayResult.TD,
    PlayResult.TeamLost,
    PlayResult.Safety,
    PlayResult.SafetyReceivingTeam
  ],
  [PlayType.Run]: [
    PlayResult.Rush,
    PlayResult.RushTD,
    PlayResult.Penalty,
    PlayResult.Sack,
    PlayResult.SackFumble,
    PlayResult.SackFumbleDefTD,
    PlayResult.Fumble,
    PlayResult.FumbleDefTD,
    PlayResult.RushSafety,
    PlayResult.TeamLost
  ],
  [PlayType.TeamLost]: [
    PlayResult.TeamLost
  ],
  [PlayType.Missing]: [
    PlayResult.Missing
  ]
}
